/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
import React from 'react'

import _ from 'lodash'

import { formatPlainDateDisplay, getTodayDateString, parsePlainDate } from '../../utils/DateUtils';

import CheckboxListInput  from './TableComponents/InputComponents/CheckboxListInput'
import DateInput from './TableComponents/InputComponents/DateInput'
import DropDownInput from './TableComponents/InputComponents/DropDownInput'
import DropDownSearch from './TableComponents/InputComponents/DropDownSearch'
import InventoryAssociationHelper  from './TableComponents/InputComponents/InputForInventoryAssociation'
import MultiPicker  from './TableComponents/InputComponents/MultiPickerInput'
import TableMultiPicker  from './TableComponents/InputComponents/TableMultiPickerInput'
import TableMultiPicker2 from './TableComponents/InputComponents/TableMultiPickerInput2'
import OptionsDropDownInput from './TableComponents/InputComponents/OptionsDropDownInput'
import PasswordInput from './TableComponents/InputComponents/PasswordInput'
import SwitchInput from './TableComponents/InputComponents/SwitchInput'
import TableSearchPicker  from './TableComponents/InputComponents/TablePicker'
import TextAreaInput from './TableComponents/InputComponents/TextAreaInput'
import ModelInput from './TableComponents/InputComponents/ModelInput'
import UploadInput from "./TableComponents/InputComponents/UploadInput"
import TextInput from './TableComponents/InputComponents/TextInput'
import NameValueInput from './TableComponents/InputComponents/NameValueInput'
import PeriodInput from './TableComponents/InputComponents/PeriodInput'
import NumberInput from './TableComponents/InputComponents/NumberInput';

import {
    CustomTableCellInput,
    CustomOutlinedInput,
    CustomOutlinedDropdownInput,
    FilterDatePickerTextField,
} from './BPMComponents';

import {
    TraficClassFilter,
    UsersRoleFilter,
    BooleanFilter,
    TextFilter,
    DateFilter,
    InvoiceStateFilter,
    ProcessControlStateFilter,
    PeriodStateFilter,
    PeriodFilter,
    PERIOD_BOUNDS,
    LanguageFilter,
    InvoicePaymentStateFilter,
    NullTextFilter,
    InvoicePaymentGroupStateFilter,
} from './BPMFilters';


class ComponentCreator{
    constructor(id, defaultValue=null){
        this.id = id;
        this.defaultValue = defaultValue;
    }

    getDefaultValue = () => {
        return this.defaultValue;
    }

    supportQueries = (props)=>[]
}

class TextAreaCreator extends ComponentCreator{
    type = 'text_area';

    create_with = (props)=>{
        return React.createElement(TextAreaInput, { ...props, inputId:this.id, defaultValue:this.defaultValue })
    }
}

class ModelCreator extends ComponentCreator{
    type = 'text_area';
    constructor(id, minimalTableInstance){
        super(id)
        this.minimalTable = minimalTableInstance;
    }
    create_with = (props)=>{
        return React.createElement(
            ModelInput,
            {
                ...props,
                inputId:this.id,
                mappers:this.minimalTable.tableFormMapper || [],
                tableCreator:this.minimalTable.getTableCreator(),
                defaultValue:this.defaultValue,
            })
    }
}

class UploadCreator extends ComponentCreator{
    type = 'upload';
    constructor(id, resourceType){
        super(id)
        this.resourceType = resourceType;
    }
    create_with = (props)=>{
        return React.createElement(UploadInput, { ...props, inputId:this.id, resourceType: this.resourceType, defaultValue:this.defaultValue })
    }
}

class PasswordCreator extends ComponentCreator{
    type = 'password';

    create_with(props){
        return React.createElement(PasswordInput, { ...props, inputId:this.id, defaultValue:this.defaultValue })
    }
}

class NameValueCreator extends ComponentCreator{
    type = 'name_value';

    create_with = (props)=>{
        return React.createElement(NameValueInput, { ...props, inputId:this.id, defaultValue:this.defaultValue })
    }
}

class TextCreator extends ComponentCreator{
    type = 'text';

    constructor(id, nullable, defaultValue=null, isNumeric=false){
        super(id, defaultValue)
        this.nullable = (nullable === undefined) || nullable;
        this.isNumeric = isNumeric;
    }

    create_with = (props)=>{
        return React.createElement(TextInput, { ...props, inputId:this.id, defaultValue:this.defaultValue, isNumeric:this.isNumeric })
    }
}

class NumberCreator extends ComponentCreator{
    type = 'number';

    constructor(id, nullable, defaultValue=null, precision=0, prefix=null, sufix=null){
        super(id, defaultValue)
        this.nullable = (nullable === undefined) || nullable;
        this.precision = precision
        this.prefix = prefix
        this.sufix = sufix
    }

    create_with = (props)=>{
        return (
            <NumberInput
                {...props}
                inputId={this.id}
                defaultValue={this.defaultValue}
                precision={this.precision}
                prefix={this.prefix}
                sufix={this.sufix}
                nullable={this.nullable}
            />
            )
    }
}

class DropDownSearchCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id, nullable){
        super(id)
        this.nullable = (nullable === undefined) || nullable;
    }

    create_with = (props)=>{
        return React.createElement(
            DropDownSearch,
            { ...props, inputId:this.id, nullable: this.nullable, defaultValue:this.defaultValue})
    }
}

class DropDownCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id, nullable){
        super(id)
        this.nullable = (nullable === undefined) || nullable;
    }

    create_with = (props)=>{
        return React.createElement(DropDownInput, { ...props, inputId: this.id, nullable: this.nullable, defaultValue:this.defaultValue})
    }
}

class TablePickerCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id, tableCreator, transformer){
        super(id)
        this.tableCreator = tableCreator;
        this.transformer = transformer;
    }
    create_with = (props)=>{
        return React.createElement(TableSearchPicker , {tableCreator:this.tableCreator, ...props, inputId:this.id, transformer: this.transformer, defaultValue:this.defaultValue})
    }
}


class MultiPickerCreator extends ComponentCreator{
    type = "text_area"
    constructor(id, query, queryName, labelTransformer, queryVariablesTransformer, watchedStateIdentifierForSelectionClear, queryItemIterator) {
        super(id)
        this.query = query;
        this.queryName = queryName;
        this.labelTransformer = labelTransformer;
        this.queryVariablesTransformer = queryVariablesTransformer;
        this.watchedStateIdentifierForSelectionClear = watchedStateIdentifierForSelectionClear;
        this.queryItemIterator = queryItemIterator;
    }
    create_with = (props)=>{
        return React.createElement(MultiPicker,
            {...props,
            inputId:this.id,
            query: this.query,
            queryName:this.queryName,
            labelTransformer:this.labelTransformer,
            queryVariablesTransformer: this.queryVariablesTransformer,
            watchedStateIdentifierForSelectionClear: this.watchedStateIdentifierForSelectionClear,
            queryItemIterator : this.queryItemIterator,
            defaultValue: this.defaultValue,
            }
        )
    }
}

class TableMultiPickerCreator2 extends ComponentCreator{
    type = "text_area"
    constructor(id, query, queryName, labelTransformer, queryVariablesTransformer, watchedStateIdentifierForSelectionClear) {
        super(id, null)
        this.query = query;
        this.queryName = queryName;
        this.labelTransformer = labelTransformer;
        this.queryVariablesTransformer = queryVariablesTransformer;
        this.watchedStateIdentifierForSelectionClear = watchedStateIdentifierForSelectionClear;
    }
    create_with = (props)=>{
        return React.createElement(TableMultiPicker2,
            {...props,
            inputId:this.id,
            query: this.query,
            queryName:this.queryName,
            labelTransformer:this.labelTransformer,
            queryVariablesTransformer: this.queryVariablesTransformer,
            watchedStateIdentifierForSelectionClear: this.watchedStateIdentifierForSelectionClear,
            }
        )
    }
}

class TableMultiPickerCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id, query, queryName, tableMultiPickerColumnTransformers, queryVariablesTransformer, watchedStateIdentifierForSelectionClear){
        super(id);
        this.id = id;
        this.query = query;
        this.queryName = queryName;
        this.tableMultiPickerColumnTransformers = tableMultiPickerColumnTransformers;
        this.queryVariablesTransformer = queryVariablesTransformer;
        this.watchedStateIdentifierForSelectionClear = watchedStateIdentifierForSelectionClear;
    }
    create_with = (props)=>{
        return React.createElement(TableMultiPicker ,
            {...props,
            inputId:this.id,
            query: this.query,
            queryName:this.queryName,
            tableMultiPickerColumnTransformers:this.tableMultiPickerColumnTransformers,
            queryVariablesTransformer: this.queryVariablesTransformer,
            watchedStateIdentifierForSelectionClear: this.watchedStateIdentifierForSelectionClear,
            }
        )
    }
}


class InventoryAssociationHelperCreator extends ComponentCreator{
    type = 'text_area';
    constructor(id,query,labelMapper){
        super(id)
        this.query = query;
        this.labelMapper = labelMapper;
    }
    create_with = (props)=>{
        return React.createElement(InventoryAssociationHelper,
            {...props,
            inputId:this.id,
            query: this.query,
            labelMapper:this.labelMapper,
            defaultValue:this.defaultValue
            }
        )
    }
}

class OptionsDropDownCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id, options, translateElements){
        super(id)
        this.options = options;
        this.translateElements = translateElements
    }
    create_with = (props)=>{
        const options = this.options;
        return React.createElement(OptionsDropDownInput, { options, ...props, inputId:this.id, defaultValue:this.defaultValue, translateElements:this.translateElements })
    }
}

class CheckboxListCreator extends ComponentCreator{
    type = 'drop_down';
    constructor(id,mapper,query,variables){
        super(id)
        this.mapper = mapper;
        this.query = query;
        this.variables = variables;
    }
    create_with = (props)=>{
        const mapper = this.mapper;
        const query = this.query;
        const variables = this.variables;
        return React.createElement(CheckboxListInput, { mapper, query, variables, ...props, inputId:this.id, defaultValue:this.defaultValue })
    }
}

class PeriodCreator extends ComponentCreator{
    type = "text_area"

    constructor(id, defaultMonth=null) {
        super(id);
        this.defaultMonth=defaultMonth;
    }

    create_with = (props)=>{
        return React.createElement(PeriodInput, { ...props, inputId: this.id, defaultMonth: this.defaultMonth})
    }
}

class DateCreator extends ComponentCreator{
    constructor(id, defaultDate=null){
        super(id, defaultDate)
    }

    type = 'date';

    create_with = (props)=>{
        return React.createElement(DateInput, { ...props, inputId:this.id, defaultValue:this.defaultValue || "" })
    }
}

class BoolCreator extends ComponentCreator{
    type = 'bool';

    create_with = (props)=>{
        return React.createElement(SwitchInput, { ...props, inputId:this.id, defaultValue:this.defaultValue })
    }
}

class NullCreator extends ComponentCreator{
    type = 'null';

    filterCreator(props){
        return(
              <CustomTableCellInput key={"cell" + props.key} />
        )
    };
    create_with = (props)=>{
        return null;
    }
}

// Validators ////////////////////////////////

class Validator {
  validate_with(value, id, label, context, t) {
        throw new Error("Method not implemented");
    }
}

class FunctionContextualComparisonValidator extends Validator{
  constructor(otherFieldId, binaryOperator, errorMessage, otherFieldLabel) {
        super();

        this.otherFieldId = otherFieldId;
        this.binaryOperator = binaryOperator;
    this.errorMessage = errorMessage;
    this.otherFieldLabel = otherFieldLabel;
    }

  validate_with(value, id, label, context, t) {
        const otherFieldValue = context[this.otherFieldId];
    const errors = {};
        if (!this.binaryOperator(value, otherFieldValue)) {
      const translatedLabel = t(`fieldLabels:${label}`);
      const translatedOtherFieldLabel = t(`fieldLabels:${this.otherFieldLabel}`);

      errors[id] = t(`validator:${this.errorMessage}`, {
        field: translatedLabel,
        otherField: translatedOtherFieldLabel,
      });
        }
        return errors;
    }
}

class CompositeValidator extends Validator {
    constructor(validators){
        super();

        this.validators = validators;
    }

  validate_with = (value, id, label, context, t) => {
        const errors = {};

        for (const validator of this.validators) {
      const result = validator.validate_with(value, id, label, context, t);
            for (const key in result) {
                if (!(key in errors)) {
                    errors[key] = result[key];
                }
            }
        }
        return errors;
    }
}

class MinDateValidator extends Validator{
  constructor(minDate = getTodayDateString()) {
        super();
    this.minDate = minDate;
    }

  validate_with = (value, id, label, context, t) => {
    if (!value || !this.minDate) {
      return {};
    }

    const candidateDate = parsePlainDate(value);
    const minDate = parsePlainDate(this.minDate);

    if (!candidateDate || !minDate) {
      return {};
    }

    if (candidateDate < minDate) {
      const translatedLabel = t(`fieldLabels:${label}`);
      const formattedMinDate = formatPlainDateDisplay(this.minDate);

            return {
        [id]: t('validator:{{field}} should be at least {{minDate}}', {
          field: translatedLabel,
          minDate: formattedMinDate,
        }),
      };
        }

    return {};
    }
}

class PasswordValidator extends Validator{
  validate_with(value, id, label, context, t) {
        let error = {};

                let count = 0;
                count += /[a-z]/.test(value) ? 1 : 0; // lower case alpha character
                count += /[A-Z]/.test(value) ? 1 : 0; // upper case alpha character
                count += /\d/.test(value)    ? 1 : 0; // numeric character
                count += /[@]/.test(value)   ? 1 : 0; // special character
                if(value.length < 1) {
                    error[id] = `${label} is requried`;
                } else if(value.length < 6) {
                    error[id] = `${label} is too short`;
                } else if(count < 2) {
                    error[id] = `${label} is too weak`;
                };

        return error;
    }
}

class RequiredValidator extends Validator{
    constructor(l=1){
        super();

        this.minLength = l;
    }

  validate_with = (value, id, label, context, t) => {
        let error = {};
        if (_.isNull(value) || _.isUndefined(value) || value.length === 0){
            error[id] = `${label} is requried`;
        }else if(value.length < this.minLength){
            error[id] = `${label}  must have ${this.minLength} characters)`;
        };
        return error;
    }
}

class EmailValidator extends Validator{
  validate_with(value, id, label, context, t) {
        let error = {};
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)){
            error[id] = `${label} is not valid`;
        };
        return error;
    }
}


class NumberValidator extends Validator{
  validate_with(value, id, label, context, t) {
        let error = {};
        const re = /^-?\d+(\.\d+)?$/;
        if (!re.test(value)){
            error[id] = `${label} is not valid`;
        };
        return error;
    }
}

class InputDescription{
    nullValidator(){return false};
    constructor(component_creator, required, validator){
        this.component_creator = component_creator;
    this.validator = validator || null;
        this.type = component_creator.type;
        this.required = required;
    }

    create_with(props){
        if (this.required){
            const required = label => <span><span style={{color:'red'}}>*</span> {label} </span> ;
            return this.component_creator.create_with({...props, required: required});
        }
        return this.component_creator.create_with(props);
    }

  validate_with(value, id, label, context, t) {
    if (!this.validator) {
      return {};
    }
    return this.validator.validate_with(value, id, label, context, t);
    }

    getFilter(props){
        return this.component_creator.filterCreator(props);
    }

    getDefaultValue() {
        return this.component_creator.getDefaultValue();
    }
}

class FilterDescription{
    nullFilter(){
        return <CustomTableCellInput  key={"cell" + props.key}/>
    };

    constructor(component_filter){
        this.component_filter = component_filter;
    }

    getFilter(props){
        if (! this.component_filter){
            return this.nullFilter(props);
        }
        return this.component_filter.filterCreator(props);
    }
}

export {
    TextAreaCreator,
    PasswordCreator,
    NameValueCreator,
    TextCreator,
    NumberCreator,
    DropDownCreator,
    DropDownSearchCreator,
    DateCreator,
    BoolCreator,
    InputDescription,
    FunctionContextualComparisonValidator,
    CompositeValidator,
    MinDateValidator,
    PasswordValidator,
    RequiredValidator,
    EmailValidator,
    NumberValidator,
    OptionsDropDownCreator,
    TablePickerCreator,
    NullCreator,
    FilterDescription,
    InventoryAssociationHelperCreator,
    CheckboxListCreator,
    MultiPickerCreator,
    TableMultiPickerCreator,
    TableMultiPickerCreator2,
    PeriodCreator,
    UploadCreator,
    ModelCreator,

    // TODO: Remove from here and correct all the imports
    TraficClassFilter,
    UsersRoleFilter,
    BooleanFilter,
    TextFilter,
    DateFilter,
    InvoiceStateFilter,
    ProcessControlStateFilter,
    PeriodStateFilter,
    PeriodFilter,
    PERIOD_BOUNDS,
    LanguageFilter,
    InvoicePaymentStateFilter,
    NullTextFilter,
    InvoicePaymentGroupStateFilter,

    // TODO: Remove from here and correct all the imports
    CustomTableCellInput,
    CustomOutlinedInput,
    CustomOutlinedDropdownInput,
    FilterDatePickerTextField
}
